import { render, staticRenderFns } from "./EchartsType.vue?vue&type=template&id=24b866f4&scoped=true&"
import script from "./EchartsType.vue?vue&type=script&lang=js&"
export * from "./EchartsType.vue?vue&type=script&lang=js&"
import style0 from "./EchartsType.vue?vue&type=style&index=0&id=24b866f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b866f4",
  null
  
)

export default component.exports